import {ComponentRef, Type, ViewContainerRef} from '@angular/core';
import {FormStrategy} from "../../shared/interface/form-strategy";

export abstract class BaseComponentResolverServiceService {
  protected activeStrategy?: FormStrategy;

  protected constructor(private strategies: { [key: string]: Type<FormStrategy> }) {
  }

  loadStrategy(type: string, viewContainerRef: ViewContainerRef, inputs: any) {
    viewContainerRef.clear();
    const componentType = this.strategies[type] || this.strategies['DEFAULT'];
    const componentRef = viewContainerRef.createComponent(componentType);
    this.setInputs(inputs, componentRef);
  }

  private setInputs(inputs: any, componentRef: ComponentRef<FormStrategy>) {
    if (inputs) {
      Object.keys(inputs).forEach((key) => {
        componentRef.setInput(key, inputs[key]);
        if (componentRef.instance.hasOwnProperty(key)) {
          componentRef.instance[key] = inputs[key];
        }
      });
    }
    this.activeStrategy = componentRef.instance;
  }

  reset(viewContainerRef: ViewContainerRef) {
    viewContainerRef.clear();
  }

  getSubFormValue() {
    return this.activeStrategy?.getForm().value;
  }

  isSubFormValid() {
    return this.activeStrategy?.getForm().valid;
  }
}
